module.exports = __webpack_public_path__ + "static/media/27OCHA19.97c27d7b.jpg";